












































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { queryQuarter, portfolioReviewList } from '@/api/document';
import { mapGetters } from 'vuex';
import { hasPermission } from '@/utils/utils';
import moment from 'moment';
import { checkFeishuLinkPermission } from '@/api/project';

const columns = [
  {
    title: '项目名称',
    dataIndex: 'companyName',
    key: 'companyName',
    width: '25%'
  },
  {
    title: 'DL',
    dataIndex: 'dlName',
    key: 'dlName',
    width: '10%'
  },
  {
    title: 'DM',
    dataIndex: 'dmNameList',
    key: 'dmNameList',
    width: '10%',
    customRender: (value, row, index) => {
      return value.join('，');
    }
  },
  {
    title: 'portfolio Review文件',
    // dataIndex: 'fileName',
    key: 'fileName',
    scopedSlots: { customRender: 'data' }
  },
  {
    title: '上传时间',
    dataIndex: 'createAt',
    key: 'createAt',
    width: '15%',
    customRender: (value, row, index) => {
      return moment(value).format('YYYY-MM-DD HH:mm');
    }
  }
];

@Component({ computed: { ...mapGetters(['userInfo']) } })
class PortfolioReview extends Vue {
  hasPermission: boolean = false;
  userInfo: any;
  listQuarter: any[] = [];
  listTitle: any[] = [];
  year: string = '';
  quarter: string = '';
  pageSize: number = 10;
  page: number = 1;
  list: any[] = [];
  columns: any[] = columns;
  tableLoading: boolean = false;
  total: number = 0;
  current: number = 1;
  tabNow: number = 0;
  searchName: string = '';

  created() {
    this.getQuarterQuery();
    this.getPermission();
  }

  getPermission() {
    const { permissions: queue } = this.userInfo || {};
    this.hasPermission = hasPermission(queue, '/document/portfolioReview/createReview');
  }

  async getQuarterQuery() {
    try {
      let res = await queryQuarter();
      if (res.code === 200) {
        this.listQuarter = res.data.sort((a, b) => {
          return b.year - a.year;
        });
        this.listTitle = this.changeQuarterList(this.listQuarter);
        this.year = this.listQuarter[0].year;
        this.quarter = this.listQuarter[0].quarter;
        this.getList();
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getList() {
    try {
      this.tableLoading = true;
      let { year, page, pageSize, quarter, searchName } = this;
      let res = await portfolioReviewList({
        year,
        page,
        pageSize,
        quarter,
        searchName
      });
      this.tableLoading = false;
      if (res.code === 200) {
        this.list = res.data.list || [];
        this.total = res.data.total;
      }
    } catch (err) {
      console.log(err);
    }
  }

  changeQuarterList(quarter) {
    let tmpList: any[] = [];
    quarter.forEach(e => {
      tmpList.push(e.year + '年' + 'H' + e.quarter);
    });
    return tmpList;
  }

  toPath(type) {
    let query = {
      type: type
    };
    if (type === 3) {
      query['year'] = this.year;
      query['quarter'] = this.quarter;
    }
    this.$router.push({
      path: '/document/portfolioReview/createReview',
      query
    });
  }

  tabChange(val) {
    let index = this.listTitle.indexOf(val);
    this.page = 1;
    this.current = 1;
    this.year = this.listQuarter[index].year;
    this.quarter = this.listQuarter[index].quarter;
    this.getList();
  }

  changePage(page, pageSize) {
    this.page = page;
    this.getList();
  }

  onShowSizeChange(current, pageSize) {
    this.pageSize = pageSize;
    this.getList();
  }

  async toFile(id) {
    try {
      let res = await checkFeishuLinkPermission({ companyFileId: id });
      if (res.code === 200) {
        window.open(res.data);
      }
    } catch (err) {
      console.log(err);
    }
  }

  handleSearch() {
    this.page = 1;
    this.current = 1;
    this.getList();
  }
}
export default PortfolioReview;
